import { render } from "./LayoutFrame.vue?vue&type=template&id=d5fe155e"
import script from "./LayoutFrame.vue?vue&type=script&lang=js"
export * from "./LayoutFrame.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__